import React, { Component } from 'react'
import { Modal, Button, TextArea } from '@driftt/tide-core-legacy'
import { api } from '../../pages/CommonIntegrationPage/api.js'

import './style.styl'

class DisconnectConfirmModal extends Component {

  constructor(props){
    super(props)
    this.state = {
      integrationFeedback: null
    }
  }

  getDisconnectNotifyCopy = (integrationName) => {
    return `Disconnect ${integrationName}?`
  }

  getDisconnectBodyCopy = (integrationName) => {
    switch(integrationName){
      case "Clearbit Enrichment":
        return "Disconnecting this integration will disable contact and profile enrichment features from your account."
      case "Clearbit Reveal":
        return "Disconnecting this integration will disable ABM targeting features from your account."
      case "Outreach":
        return `Any prospects currently in a sequence will still be enrolled.`
      case "Salesforce":
      case "Marketo":
      case "Hubspot":
      case "Eloqua":
      case "Pardot":
        return `We’ll keep your mapped attributes and users, but your data will no longer be synced between ${integrationName} and Drift.`
      default:
        return `Your data will no longer be synced between ${integrationName} and Drift.`
    }   
  }

  feedbackChange = (event) =>{
    this.setState({
      integrationFeedback: event
    })
  }

  innerDisconnect = async () => {
    if(!!this.state.integrationFeedback){
      try{
      await api.postIntegrationFeedback(this.props.integrationName, this.state.integrationFeedback)
      }
      catch(e){
        console.log(e)
      }
    }
    this.props.onDisconnect()
  }

  render() {
    const { onClose, integrationName, open } = this.props
    return (
      <div className="disconnect-confirm">
        <Modal
          size="small"
          className="disconnect-confirm-modal"
          type="warning"
          onClose={onClose}
          open={open}>
          <div className="disconnect-confirm-modal-content">
            <div className="disconnect-confirm-modal-notify">
              <h1 className="disconnect-header">{this.getDisconnectNotifyCopy(integrationName)}</h1>
            </div>
            <div className="disconnect-modal-copy">
              {this.getDisconnectBodyCopy(integrationName)}
            </div>
            <div className="disconnect-feedback-holder">
              <p className="disconnect-feedback-header">Feedback (optional)</p>
              <TextArea className="disconnect-textarea" size="large" placeholder="Have some feedback about this integration? Let us know!" onChange={this.feedbackChange}/>
            </div>
          </div>

          <div className="disconnect-button-section">
            <Button onClick={this.innerDisconnect} type="secondary" className="modal-disconnect-button">
              {`Disconnect ${integrationName}`}
            </Button>
            <Button onClick={onClose} type="tertiary">
              Nevermind
            </Button>
          </div>
        </Modal>
      </div>
    )
  }
}
export default DisconnectConfirmModal



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/DisconnectConfirmModal/index.js